export const workExperienceColor = '#689bf2'
export const educationExperienceColor = '#d64c33'